import React, { useState, useEffect, useContext } from "react";
import Preloader from "./components/Preloader";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import ScrollToTop from "./components/ScrollToTop";
import Skills from "./components/Resume/skils";
import Contect from "./components/Contact";

import { CartContext } from "./Context/Context";

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);
  const {Theme}  = useContext(CartContext)

  return (
    <Router>
      {load ? (
        <Preloader load={load} />
      ) : (
        <div  className={Theme === "light" ? "themecolor-light" : "themecolor-dark"} id={load ? "no-scroll" : "scroll"}>
          <Navbar />
          <ScrollToTop />
        
          {/* <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/project" component={Projects} />
            <Route path="/skill" component={Skills} />
            <Route path="/about" component={About} />
            <Route path="/resume" component={Resume} />
            <Route path="/contact" component={Contect} />
          </Switch> */}
      <Home/>
      {/* <Toogle/> */}
<About/>
<Skills/>
          <Projects/>
          <Contect/>

          <Footer />
  
        </div>
      )}
    </Router>
  );
}

export default App;
